<template>
    <v-container v-if="superUser || permissions.read" fluid class="b-container">
        <v-sheet class="pa-3" :class="{ 'mx-3': tabsWithMargin }">
            <v-tabs
                v-model="tab"
                color="secondary"
                :vertical="$vuetify.breakpoint.mdAndDown"
                show-arrows
            >
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.name['en']"
                    v-text="tab.name[lang]"
                    :to="tab.to"
                    :class="
                        tab.to == `/${lang}/${panelType}/generalSettings/billingDashboard`
                            ? 'ml-auto my-subscription'
                            : ''
                    "
                    class="
                        text-capitalize text-left text-md-center
                        justify-start justify-md-center
                        px-3
                    "
                ></v-tab>
            </v-tabs>
        </v-sheet>

        <v-tabs-items v-model="tab" class="mt-3">
            <router-view></router-view>
        </v-tabs-items>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "Settings",

    data() {
        return {
            tab: this.$route.path,
        };
    },

    computed: {
        ...mapState(["superUser", "panelType"]),

        lang() {
            return this.$route.params.lang;
        },

        paymentError() {
            return this.$store.state.storePanel.paymentError;
        },

        permissions() {
            return this.$store.state.permissions.settings
                ? this.$store.state.permissions.settings
                : { users: {} };
        },

        storePermissions() {
            return this.$store.state.storePermissions.settings
                ? this.$store.state.storePermissions.settings
                : { users: {} };
        },

        tabs() {
            let arr = [];

            if (
                this.superUser ||
                (this.permissions.profile &&
                    this.storePermissions.profile &&
                    !this.paymentError)
            ) {
                arr.push({
                    name: { el: "Προφίλ", en: "profile", it: "Profilo" },
                    to: `/${this.lang}/storePanel/settings/profile`,
                });
            }

            if (
                this.superUser ||
                (this.permissions.reward &&
                    this.storePermissions.reward &&
                    !this.paymentError)
            ) {
                arr.push({
                    name: { el: "Ανταμοιβή", en: "reward", it: "Ricompensa" },
                    to: `/${this.lang}/storePanel/settings/reward`,
                });
            }

            if (
                this.superUser ||
                (this.permissions.product_points &&
                    this.storePermissions.product_points &&
                    !this.paymentError)
            ) {
                arr.push({
                    name: {
                        el: "Πόντοι προϊόντος",
                        en: "product points",
                        it: "Punti del prodotto",
                    },
                    to: `/${this.lang}/storePanel/settings/product-points?page=1`,
                });
            }

            if (
                this.superUser ||
                (this.permissions.users&&this.permissions.users.read &&
                    this.storePermissions.users.read &&
                    !this.paymentError)
            ) {
                arr.push({
                    name: { el: "Χρήστες", en: "users", it: "Utenti" },
                    to: `/${this.lang}/storePanel/settings/users?page=1`,
                });
            }

            if (
                this.superUser ||
                (this.permissions.cleaners &&
                    this.storePermissions.cleaners &&
                    !this.paymentError)
            ) {
                arr.push({
                    name: {
                        el: "Πάροχοι πληρωμών",
                        en: "payment providers",
                        it: "Fornitori di pagamento",
                    },
                    to: `/${this.lang}/storePanel/settings/payment-providers`,
                });
            }

            if (
                this.superUser ||
                (this.permissions.payment_routing &&
                    this.storePermissions.payment_routing &&
                    !this.paymentError)
            ) {
                arr.push({
                    name: {
                        el: "Επεξεργασία πληρωμής",
                        en: "payment processing",
                        it: "Processo di pagamento",
                    },
                    to: `/${this.lang}/storePanel/settings/payment-processing`,
                });
            }


            return arr;

            // {
            //     name: { el: "", en: "cards", it: "" },
            //     to: `/${this.lang}/storePanel/settings/cards`
            // },
            // {
            //     name: { el: "", en: "payment history", it: "" },
            //     to: `/${this.lang}/storePanel/settings/payment-history`
            // },
            // {
            //     name: { el: "", en: "payment methods", it: "" },
            //     to: `/${this.lang}/storePanel/settings/payment-methods`
            // }
        },

        tabsWithMargin() {
            return (
                this.$route.path === `/${this.lang}/storePanel/settings/profile`
            );
        },
    },

    watch: {
        tabs: {
            immediate: true,
            handler(val) {
                if (val.length) {
                    if (!this.permissions.read && !this.superUser) {
                        this.$router.replace(
                            `/${this.lang}/storePanel/forbidden-gateway`
                        );
                    } else if (
                        this.$route.path === `/${this.lang}/storePanel/settings`
                    ) {
                        this.$router.replace(val[0].to);
                    }
                }
            },
        },
    },
};
</script>

<style lang="scss">
.dashed {
    border: 1px dashed grey;
    border-radius: 10px;
}

.relative {
    position: relative;
}

.theme--light.v-tabs > .v-tabs-bar {
    width: 100%;
}

.v-tabs-bar.v-item-group > * {
    width: 100%;
}

.v-slide-group__content {
    width: 100%;
}

.my-subscription {
    background-color: #2a3042;
    color: white !important;
    border-radius: 5px 5px 0px 0px;
}
</style>
